import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../context/LanguageContext';

const PageTitle = (props) => {
    const { t } = useLanguage();
    const bgImage = props.bgImage || '/banner/urunler.png';
    return (
        <section
            className="wpo-page-title"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-breadcumb-wrap">
                            <h2>{props.pageTitle}</h2>
                            <ol className="wpo-breadcumb-wrap">
                                <li><Link to="/home">{t('pages.home')}</Link></li>
                                <li>{props.pagesub}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageTitle;
